<app-logo [nzTooltipMouseEnterDelay]="1" nz-tooltip [nzTooltipTitle]="serverConfig?.name" [size]="30" />

@if (serverConfig()?.code | hasValue) {
  <div class="environment-strip" [ngStyle]="{ color: serverConfig()?.color }">
    <div class="environment-code">
      {{ serverConfig()!.code }}
    </div>
  </div>
}
<div nz-menu class="closed" nzMode="vertical" nzTheme="dark" [nzSelectable]="false">
  <div id="nav-top">
    <app-menu-item
      title="Dashboard"
      i18n-title
      link="dashboard"
      *appPermission="{ permissions: ['Web.DashboardUse'] }"
      iconName="objects-column"
    />
    <app-menu-item
      iconName="fire"
      title="Interventies"
      link="intervention/overview"
      i18n-title
      [submenuItems]="interventionSubmenu"
    />
    <app-menu-item
      link="round/requests"
      title="Rondes"
      i18n-title
      iconName="clipboard-list-check"
      [submenuItems]="roundSubmenu"
      *appPermission="{ permissions: ['InTheField.RoundManage'] }"
    />
    <app-menu-item
      iconName="user"
      title="Personen"
      i18n-title
      link="person/overview"
      [submenuItems]="personSubmenu"
      *appPermission="{ permissions: ['Web.PersonSearch', 'Web.PersonPropertyValues'], inclusivity: 'some' }"
    />

    <app-menu-item
      iconName="truck-fire"
      i18n-title
      link="vehicle/physical/overview"
      iconSizeOverride="18px"
      [submenuItems]="vehicleSubmenu"
      *appPermission="{
        permissions: [
          'Web.VehicleSearch',
          'Web.VehicleTrackAndTrace',
          'Web.UnitPositionView',
          'Web.UnitTypeView',
          'Web.UnitStatusHistory',
          'Web.UnitOverview',
          'Web.UnitView',
          'Web.UnitEdit',
        ],
        inclusivity: 'some',
      }"
    />

    <app-menu-item
      *appPermission="{
        permissions: [
          'Web.AvailabilityCalculator',
          'Web.StandbyInformation',
          'Web.DatabaseAudit',
          'Web.DatabaseService',
          'Web.QueryTool',
          'Web.AlertLog',
        ],
        inclusivity: 'some',
      }"
      iconName="database"
      title="Informatie"
      i18n-title
      link="information"
    />
    <app-menu-item
      *appPermission="{ permissions: ['Web.IncidentFlowUse'] }"
      iconName="diagram-subtask"
      title="Interventie formulieren"
      i18n-title
      link="incident-flows"
    />
  </div>
  <div id="nav-bottom">
    <app-menu-item title="Configuratie" i18n-title link="configuration" iconName="cog" />
    <app-user-switch nz-tooltip="Rol wisselen" i18n-nz-tooltip="Rol wisselen" />
    <a
      nz-tooltip="FrontForce Klassiek"
      i18n-nz-tooltip
      nz-menu-item
      href="/FrontForce"
      target="_blank"
      (click)="onClickClassic($event)"
    >
      <img src="assets/icons/old-icon.png" />
    </a>
    <a nz-tooltip="Uitloggen" i18n-nz-tooltip nz-menu-item [nzSelected]="false" (click)="onLogOut()">
      <i appIcon="sign-out" faStyle="thin"></i>
    </a>
  </div>
</div>
